import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
// All pages
import CustomSoftware from './pages/CustomSoftware';
import ProcessImprovement from './pages/ProcessImprovement';
import ProjectLeadership from './pages/ProjectLeadership';
import Home from './pages/Home';
import Contact from './pages/Contact';
import DemoProduct from './pages/DemoProduct';
import AboutUs from './pages/AboutUs';

import {useDocTitle} from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';

function App() {
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    }

    window.addEventListener('load', () => {
      aos_init();
    });
  }, []);

  useDocTitle("Claravio Solutions");

  return (
    <>
      <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/get-demo" element={<DemoProduct />} /> 
            <Route path="/about" element={<AboutUs />} />
            <Route path="/services/custom-software" element={<CustomSoftware />} />
            <Route path="/services/process-improvement" element={<ProcessImprovement />} />
            <Route path="/services/project-leadership" element={<ProjectLeadership />} />
          </Routes>
        </ScrollToTop>
      </Router>
    </>
  );
}


export default App;
